import routes from 'sitewide-js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';

export async function retrieveDownloadUrl(workId: number): Promise<string> {
  const response = await fetchWithCsrf(
    routes.api_v0_community_pdf_download_url_path({
      subdomain_param: 'api',
      work_id: workId,
    }),
  );
  if (response.status !== 200) {
    throw new Error('Failed to generate download URL');
  }
  return (await response.json()).pdf_url;
}

export const createBookmark = async (workId: number, source: string) => {
  const response = await fetchWithCsrf(
    routes.api_v0_community_bookmark_index_path({
      subdomain_param: 'api',
    }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        work_id: workId,
        source: source,
      }),
    },
  );
  if (response.status !== 200) {
    throw new Error('Failed to create bookmark');
  }
  return await response.json();
};
